
export default {
    getCurlCommand(method, apiUrl, params)
    {
        return `curl --request ${method} --url "${apiUrl}${params}"`
    },
    getNodeCommand(method, apiUrl, params)
    {
        const url = new URL(apiUrl);

        return `const http = require("https");
           
const options = {
  "method": "${method}",
  "hostname": "${url.hostname}",
  "port": null,
  "path": "${url.search}${params}",
  "headers": {}
};

const req = http.request(options, function (res) {
  const chunks = [];

  res.on("data", function (chunk) {
    chunks.push(chunk);
  });

  res.on("end", function () {
    const body = Buffer.concat(chunks);
    console.log(body.toString());
  });
});

req.end();`
    },
    getPythonCommand(method, apiUrl, params)
    {
        const url = new URL(apiUrl);

        return `import http.client
    
conn = http.client.HTTPSConnection("${url.hostname}")

conn.request("${method}", "${url.search}${params}")

res = conn.getresponse()
data = res.read()

print(data.decode("utf-8"))`
    },
    getPhpCommand(method, apiUrl, params)
    {
        return `$curl = curl_init();

curl_setopt_array($curl, [
  CURLOPT_URL => "${apiUrl}${params}",
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => "",
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 30,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => "${method}",
]);

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
  echo "cURL Error #:" . $err;
} else {
  echo $response;
}`
    },
    getGolangCommand(method, apiUrl, params)
    {
        return `package main

import (
    "fmt"
    "net/http"
    "io/ioutil"
)

func main() {
    url := "${apiUrl}${params}"
    req, _ := http.NewRequest(${method}, url, nil)
    res, _ := http.DefaultClient.Do(req)
    defer res.Body.Close()
    body, _ := ioutil.ReadAll(res.Body)

    fmt.Println(res)
    fmt.Println(string(body))
}`
    },
    getJavaCommand(method, apiUrl, params)
    {
        return `HttpResponse<String> response = Unirest.get("${apiUrl}${params}").asString();`
    },
    getDotnetCommand(method, apiUrl, params)
    {
        return `var client = new RestClient("${apiUrl}${params}");
var request = new RestRequest(Method.GET);
IRestResponse response = client.Execute(request);`
    },
    getRubyCommand(method, apiUrl, params)
    {
        return `require 'uri'
require 'net/http'
require 'openssl'

url = URI("${apiUrl}${params}")

http = Net::HTTP.new(url.host, url.port)
http.use_ssl = true
http.verify_mode = OpenSSL::SSL::VERIFY_NONE

request = Net::HTTP::Get.new(url)

response = http.request(request)
puts response.read_body`
    }
}